export default "__VITE_ASSET__DJXoTm3N__"